import React from 'react';

import SelectedProductItem from 'components/SelectedProductItem';
import { useSelector } from 'react-redux';
import Divider from 'shared/Divider';
import { Typography } from 'shared/Houston';
import { selectOrderBumpPreview } from 'store/selectors/orderBumpPreview';
import { enOrderBumpStatus } from 'types/enums';

import { Row, OfferTitle, TypographyPosition } from './styles';

const Info: React.FC = () => {
  const { title, items, mainProduct } = useSelector(selectOrderBumpPreview);
  return (
    <>
      <OfferTitle alignItems='center' justifyContent='flex-start'>
        <Typography size='xs' weight='semibold'>
          Título da oferta: &nbsp;
        </Typography>
        <Typography size='xs'>{title || 'Sem título de oferta'}</Typography>
      </OfferTitle>
      <Divider margin='16px 0' />
      <Row>
        <Typography size='xs' weight='semibold' marginBottom>
          Produto Principal
        </Typography>
      </Row>

      {mainProduct && <SelectedProductItem product={mainProduct} isPreview />}

      <Divider margin='16px 0' />

      <div style={{ marginTop: 16 }}>
        <Typography size='xs' weight='semibold' marginBottom>
          Order Bump
        </Typography>
      </div>

      {items
        ?.filter(item => item.status !== enOrderBumpStatus.REMOVED)
        .map((bump, index) => (
          <>
            <TypographyPosition size='xxxs'>#{index++} Order Bump</TypographyPosition>
            <SelectedProductItem product={bump} isPreview />

            {index + 1 !== items.length && <Divider margin='0 0 16px' />}
          </>
        ))}
    </>
  );
};

export default React.memo(Info);
